import { Trans, useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { successToast } from "@idwal/idwal-react-components";
import { useNavigate } from "react-router-dom";
import { QUOTATIONS_ROUTE } from "../../config/router";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { quotationsSelector } from "../../features/quotationsSlice";
import { QuotationStatus } from "../../constants/QuotationConstants";
import {
    orderInspectionSelector,
    postOrderInspectionThunk,
} from "../../features/orderInspectionSlice";

export const QuotationActionsAndPrice = () => {
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const {
        SelectedQuotation,
        SelectedQuotationExtras
    } = useAppSelector(quotationsSelector);

    const {postOrderInspectionStatus} = useAppSelector(orderInspectionSelector);

    const onClickSaveForLater = () => {
        successToast(t("quotations.details.savedQuotation"));
        navigate(`/${QUOTATIONS_ROUTE}`);
    }

    const orderInspection = () => {
        dispatch(postOrderInspectionThunk(SelectedQuotation!.id));
    }

    const calculatePrice = () => {
        var priceString = "Pending";
        if (!SelectedQuotation || SelectedQuotation.status === QuotationStatus.LEAD) {
            return "Pending";
        }

        let price = SelectedQuotation.pricingDetails?.priceTotal || 0;

        const extrasPrice = SelectedQuotationExtras.reduce((acc, extra) => {
            return acc + (extra.selectedByCustomer ? extra.priceForCustomer : 0);
        }, 0);

        price += extrasPrice;
        priceString = `$${price.toFixed(0)}`;

        return priceString;
    }

    const enableOrderButton = SelectedQuotation?.status === QuotationStatus.OFFER;
    const enableSaveButton = SelectedQuotation?.status === QuotationStatus.LEAD || SelectedQuotation?.status === QuotationStatus.OFFER;

    const orderLoading = postOrderInspectionStatus === "pending";

    return (
        <>
            <div className="flex justify-content-center mt-2">
                <Trans
                    i18nKey={"orderInspection.tsandcs"}
                    components={[
                        <a className={"ml-1 summary-link"} href={"https://www.idwalmarine.com/terms-and-conditions/general-inspections"} target={"_blank"} />
                    ]
                    }></Trans>
            </div>
            <div
                className="quotation-action-buttons"
            >
                <Button
                    label={t("quotations.details.saveForLater")}
                    data-cy={"quotation-save-for-later"}
                    className="p-button p-button-outlined p-button-secondary secondary-outlined-button ml-3 mr-2 white-space-nowrap"
                    onClick={onClickSaveForLater}
                    disabled={!enableSaveButton} />
                <Button
                    loading={orderLoading}
                    label={t("quotations.details.orderInspection")}
                    className={"p-button order-inspection-button w-6"}
                    data-cy={"quotation-order-inspection"}
                    onClick={orderInspection}
                    disabled={!enableOrderButton} />
                <div
                    id="quotation-total-price-container"
                    className="quotation-total-price-container flex flex-column align-items-center justify-content-center ml-2 mr-3"
                    data-cy="quotation-total-price-container"
                >
                    <div className="light-text white-space-nowrap">
                        {t("quotations.details.totalPrice")}
                    </div>
                    <div className="quotation-total-price">
                        {calculatePrice()}
                    </div>
                </div>
            </div>
        </>

    )
}
